import React, { useState } from 'react'
import { FileText, History, User, ChevronDown, ChevronUp } from 'lucide-react'
import youteEducation from "../assets/images/youteEducation.png"
import { Link } from 'react-router-dom'
import { path } from '../Utils/ScreenPath'
import Header from './Header'
import { useDispatch, useSelector } from 'react-redux'

export default function Layout({ children, HeadersPath }) {
    const reduxData = useSelector((state) => state)
    const dispatch = useDispatch();
    const { pathname } = window.location
    const [isSidebarOpen, setIsSidebarOpen] = useState(false)
    const [subMenuOpen, setSubMenuOpen] = useState({
        paperGenerate: true,
        manuallyGenerate: true
    })

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen)
    }
    const togglePaperGenerate = (name, value) => {
        return () => {
            setSubMenuOpen({ ...subMenuOpen, [name]: !value })
        }
    }


    return (
        <>
            <div className="hidden md:flex h-screen bg-[#F6F7F9]">
                {/* Sidebar */}
                <aside
                    className={`bg-[#323232] m-3 overflow-auto rounded-3xl text-white w-64 space-y-6 py-7 px-2 absolute inset-y-0 left-0 transform ${isSidebarOpen ? 'translate-x-0' : '-translate-x-[106%]'
                        } md:relative md:translate-x-0 transition duration-200 ease-in-out z-20`}
                >
                    <div className="flex items-center space-x-2 px-4" style={{ display: 'flex', justifyContent: 'space-around' }}>
                        <img src={youteEducation} alt="logo" />
                    </div>
                    <nav style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                        <button
                            onClick={togglePaperGenerate("paperGenerate", subMenuOpen?.paperGenerate)}
                            className="block py-2.5 px-4 rounded-lg transition duration-200  hover:bg-gray-700 w-full text-left"
                            style={{ backgroundColor: pathname.includes(path.PaperGenerate) ? "#138CE3" : "transparent" }}
                        >
                            <div className="flex items-center justify-between">
                                <div className="flex items-center space-x-2">
                                    <FileText className="w-6 h-6" />
                                    <span className="sideBarTextClass">Paper Generate</span>
                                </div>
                                {subMenuOpen?.paperGenerate ? <ChevronUp className="w-4 h-4" /> : <ChevronDown className="w-4 h-4" />}
                            </div>
                        </button>
                        {subMenuOpen?.paperGenerate && (
                            <div className="pl-6 space-y-2">
                                <a className="block py-2 px-4 rounded transition duration-200 hover:bg-gray-700"
                                    onClick={togglePaperGenerate("manuallyGenerate", subMenuOpen?.manuallyGenerate)}>
                                    <div className="flex items-center justify-between">
                                        <div className="flex items-center space-x-2">
                                            <span className="sideBarTextClass">Manually Generate</span>
                                        </div>
                                        {subMenuOpen?.manuallyGenerate ? <ChevronUp className="w-4 h-4" /> : <ChevronDown className="w-4 h-4" />}
                                    </div>
                                </a>
                                {subMenuOpen?.manuallyGenerate &&
                                    <>
                                        <Link to={path.SectionWise} className="sideBarTextClass block py-2 px-4 rounded transition duration-200 hover:bg-gray-700"
                                            style={{ color: pathname === path.SectionWise ? "#108EE3" : "white", fontWeight: pathname === path.SectionWise ? "500" : "normal" }}>
                                            Section Wise Exam Paper
                                        </Link>
                                        <Link to={path.WithoutSection} className="sideBarTextClass block py-2 px-4 rounded transition duration-200 hover:bg-gray-700"
                                            style={{ color: pathname === path.WithoutSection ? "#108EE3" : "white", fontWeight: pathname === path.WithoutSection ? "500" : "normal" }}>
                                            Without Section Wise Paper
                                        </Link>
                                    </>
                                }
                                <Link to={path.AutoGenerate} className="sideBarTextClass block py-2 px-4 rounded transition duration-200 hover:bg-gray-700"
                                    style={{ color: pathname === path.AutoGenerate ? "#108EE3" : "white", fontWeight: pathname === path.AutoGenerate ? "500" : "normal" }}>
                                    Auto Generate
                                </Link>
                                <Link to={path.RandomGenerate} className="sideBarTextClass block py-2 px-4 rounded transition duration-200 hover:bg-gray-700"
                                    style={{ color: pathname === path.RandomGenerate ? "#108EE3" : "white", fontWeight: pathname === path.RandomGenerate ? "500" : "normal" }}>
                                    Random Generate
                                </Link>
                                <Link to={path.SamplePaper} className="sideBarTextClass block py-2 px-4 rounded transition duration-200 hover:bg-gray-700"
                                    style={{ color: pathname === path.SamplePaper ? "#108EE3" : "white", fontWeight: pathname === path.SamplePaper ? "500" : "normal" }}>
                                    Sample Paper
                                </Link>
                            </div>
                        )}
                        <Link to={path.PaperHistory} className="block py-2.5 px-4 rounded transition duration-200 hover:bg-gray-700"
                            style={{ backgroundColor: pathname.includes(path.PaperHistory) ? "#138CE3" : "transparent" }}>
                            <div className="flex items-center space-x-2">
                                <History className="w-6 h-6" />
                                <span className="sideBarTextClass" style={{ color: "white", fontWeight: pathname === path.PaperHistory ? "500" : "normal" }}>Paper History</span>
                            </div>
                        </Link>
                        <Link to={path.Profile} className="block py-2.5 px-4 rounded transition duration-200 hover:bg-gray-700"
                            style={{ backgroundColor: pathname.includes(path.Profile) ? "#138CE3" : "transparent" }}>
                            <div className="flex items-center space-x-2">
                                <User className="w-6 h-6" />
                                <span className="sideBarTextClass" style={{ color: "white", fontWeight: pathname === path.Profile ? "500" : "normal" }}>Profile</span>
                            </div>
                        </Link>
                    </nav>
                </aside>

                <div className="flex-1 flex flex-col overflow-hidden">
                    <Header
                        HeadersPath={HeadersPath}
                        toggleSidebar={toggleSidebar}
                    />

                    {/* Main content */}
                    <main className="flex-1 overflow-x-hidden overflow-y-auto pr-3 pl-3">{children}</main>
                </div>

                {/* Overlay for mobile */}
                {isSidebarOpen && (
                    <div
                        className="fixed inset-0 bg-black bg-opacity-50 z-10 md:hidden"
                        onClick={toggleSidebar}
                        aria-hidden="true"
                    />
                )}
            </div>
        </>
    )
}